// src/features/permissions/components/RoleInfoCard.tsx
import { Card } from '../../../app/components/foundation';
import type { SecurityRole } from '../../security/types/security.types';

export interface RoleInfoCardProps {
  role: SecurityRole;
}

/**
 * Workspace card: this role's identity — name, description, and
 * created date. Reads straight off the `role` record returned by
 * usePermissionWorkspaceMock (no separate mock map needed, same as
 * how AnalyticsWorkspaceHeader reads fields directly off its
 * `record`). Same field-list markup as
 * monitoring/components/MonitoringHealthCard.tsx and
 * analytics/components/AnalyticsOverviewCard.tsx (dl fields).
 */
export function RoleInfoCard({ role }: RoleInfoCardProps) {
  return (
    <Card className="vania-permissions-workspace-card">
      <h2 className="vania-permissions-workspace-card-title">اطلاعات نقش</h2>

      <dl className="vania-permissions-workspace-fieldlist">
        <div>
          <dt>نام نقش</dt>
          <dd>{role.name}</dd>
        </div>
        <div>
          <dt>توضیحات</dt>
          <dd>{role.description}</dd>
        </div>
        <div><dt>حوزه</dt><dd>{role.scope === 'system' ? 'SYSTEM' : 'TENANT'}</dd></div>
        <div><dt>تننت</dt><dd>{role.scope === 'system' ? 'Global' : role.tenant_name || role.tenant_id || '-'}</dd></div>
      </dl>
    </Card>
  );
}
